var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidUserIds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 10.0023V15.3356M15.501 20.6689H15.5143M13.6547 3.19122L2.68822 22.1334C2.07995 23.184 1.77581 23.7094 1.82076 24.1405C1.85997 24.5166 2.05699 24.8583 2.3628 25.0807C2.71341 25.3356 3.32043 25.3356 4.53446 25.3356H26.4675C27.6815 25.3356 28.2885 25.3356 28.6391 25.0807C28.945 24.8583 29.142 24.5166 29.1812 24.1405C29.2261 23.7094 28.922 23.184 28.3137 22.1334L17.3472 3.19122C16.7411 2.14434 16.4381 1.6209 16.0427 1.44509C15.6978 1.29174 15.3041 1.29174 14.9592 1.44509C14.5639 1.6209 14.2608 2.14434 13.6547 3.19122Z",
    stroke: "#F37820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidUserIds);
export default __webpack_public_path__ + "static/media/invalid-userIds.671b1899fc50f869ddd25504440f9910.svg";
export { ForwardRef as ReactComponent };